"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var hierarchical_select_settings_1 = require("./hierarchical-select-settings");
var idm_validation_calculation_service_client_js_1 = require("@synisys/idm-validation-calculation-service-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var immutable_1 = require("immutable");
var utilities_1 = require("../utilities");
var abstract_destruction_subject_1 = require("../abstract-destruction-subject");
var of_1 = require("rxjs/observable/of");
var zip_1 = require("rxjs/observable/zip");
require("./hierarchical-select.component.scss");
var combineLatest_1 = require("rxjs/observable/combineLatest");
/**
 * @author tatevik.marikyan
 * @since 25/06/2018
 */
var HierarchicalSelectComponent = /** @class */ (function (_super) {
    __extends(HierarchicalSelectComponent, _super);
    function HierarchicalSelectComponent(currentLanguageProvider, classifierService, languageService, ref, validationService) {
        var _this = _super.call(this) || this;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this.classifierService = classifierService;
        _this.languageService = languageService;
        _this.ref = ref;
        _this.validationService = validationService;
        _this.validations = [];
        _this.valueChange = new core_1.EventEmitter();
        _this.validationEmitter = new core_1.EventEmitter();
        _this.isReady = false;
        _this.categoryFieldsMapping = immutable_1.Map();
        return _this;
    }
    HierarchicalSelectComponent.prototype.ngOnChanges = function (changes) {
        if (changes['switchModes'] && changes['switchModes'].currentValue) {
            this.currentSwitchMode = this.entity
                ? changes['switchModes'].currentValue[0]
                : ['drillDown'];
        }
        if (changes['entity'] && changes['entity'].currentValue) {
            this.init();
        }
    };
    HierarchicalSelectComponent.prototype.ngOnInit = function () {
        this.parseStringOfArrays();
        this.initComponentId();
    };
    HierarchicalSelectComponent.prototype.onValueChange = function (lastLevelData) {
        this.valueChange.emit(lastLevelData);
    };
    HierarchicalSelectComponent.prototype.parseStringOfArrays = function () {
        if (this.switchModes === '') {
            this.switchModesArray = [];
        }
        else {
            this.switchModesArray =
                typeof this.switchModes === 'string'
                    ? JSON.parse(this.switchModes)
                    : this.switchModes;
        }
        if (this.selectedItemCategories === '') {
            this.selectedItemCategoriesArray = [];
        }
        else {
            this.selectedItemCategoriesArray =
                typeof this.selectedItemCategories === 'string'
                    ? JSON.parse(this.selectedItemCategories)
                    : this.selectedItemCategories;
        }
        if (this.selectedItemFields === '') {
            this.selectedItemFieldsArray = [];
        }
        else {
            this.selectedItemFieldsArray =
                typeof this.selectedItemFields === 'string'
                    ? JSON.parse(this.selectedItemFields)
                    : this.selectedItemFields;
        }
    };
    HierarchicalSelectComponent.prototype.isRequired = function () {
        var _this = this;
        var isRequired = false;
        this.requiredMetaFields.forEach(function (nextItem) {
            if (_this.selectedItemFieldsArray.indexOf(nextItem.getSystemName()) >
                -1) {
                isRequired = true;
            }
        });
        return isRequired;
    };
    HierarchicalSelectComponent.prototype.validationEmitterHandler = function () {
        this.validationEmitter.emit();
    };
    HierarchicalSelectComponent.prototype.switchMode = function (switchMode) {
        this.currentSwitchMode = switchMode;
    };
    HierarchicalSelectComponent.prototype.checkOneModeCase = function () {
        if (this.switchModesArray && this.switchModesArray.length === 1) {
            this.currentSwitchMode = this.switchModesArray[0];
        }
    };
    HierarchicalSelectComponent.prototype.trackByFunc = function (index, item) {
        return index;
    };
    /**
     * Initializes JSON Title to MultilingualString Title
     */
    HierarchicalSelectComponent.prototype.initTitle = function () {
        if (this.title !== undefined &&
            this.title !== null &&
            this.title !== '' &&
            !(this.title instanceof idm_crosscutting_concepts_frontend_1.MultilingualString)) {
            this.title = utilities_1.stringToMultilingual(this.title);
        }
    };
    HierarchicalSelectComponent.prototype.initCategoryFieldsMapping = function () {
        var _this = this;
        if (this.selectedItemFieldsArray &&
            this.selectedItemCategoriesArray &&
            this.selectedItemFieldsArray.length !==
                this.selectedItemCategoriesArray.length) {
            throw new Error('Items length is not compatible');
        }
        if (this.selectedItemFieldsArray) {
            this.selectedItemFieldsArray.forEach(function (itemField, index) {
                _this.categoryFieldsMapping = _this.categoryFieldsMapping.set(_this.selectedItemCategoriesArray[index], itemField);
            });
        }
    };
    HierarchicalSelectComponent.prototype.init = function () {
        var _this = this;
        // First item will be always default mode for switch control
        this.isReady = false;
        this.parseStringOfArrays();
        this.currentSwitchMode = this.switchModesArray[0];
        this.initCategoryFieldsMapping();
        var languages$ = this.languageService.getInputLanguages();
        var currentLanguageId$ = this.currentLanguageProvider.getCurrentLanguage();
        var requiredMetaFields$ = this
            .entityCategorySystemName
            ? this.validationService.getCategoryRequiredMetaFieldIds(this.entityCategorySystemName)
            : of_1.of([]);
        var viewModeValue$ = this.getViewModeValue();
        if (this.componentDataSubscription !== undefined) {
            this.componentDataSubscription.unsubscribe();
        }
        this.componentDataSubscription = combineLatest_1.combineLatest(languages$, currentLanguageId$, requiredMetaFields$, viewModeValue$)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (data) {
            _this.languages = data[0];
            _this.currentLanguageId = data[1].getId();
            _this.requiredMetaFields = data[2];
            _this.viewModeValue = data[3];
            _this.checkOneModeCase();
            _this.initTitle();
            _this.isReady = true;
        }, function (err) { return console.error(err); });
    };
    HierarchicalSelectComponent.prototype.getViewModeValue = function () {
        var _this = this;
        if (this.viewMode) {
            var classifierNames$_1 = [];
            if (this.entity) {
                this.categoryFieldsMapping.forEach(function (metaField, categoryName) {
                    var classifier = _this.entity.getProperty(metaField).value;
                    if (classifier !== null) {
                        classifierNames$_1.push(_this.classifierService.getEntityName(categoryName, classifier));
                    }
                });
            }
            if (classifierNames$_1.length !== 0) {
                return zip_1.zip.apply(void 0, classifierNames$_1).pipe(operators_1.map(function (classifierNames) {
                    return classifierNames.join(' > ');
                }));
            }
            else {
                return of_1.of(undefined);
            }
        }
        else {
            return of_1.of('');
        }
    };
    HierarchicalSelectComponent.prototype.initComponentId = function () {
        this.id += this.selectedItemFieldsArray.join('-');
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalSelectComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HierarchicalSelectComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HierarchicalSelectComponent.prototype, "title", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalSelectComponent.prototype, "titleKey", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalSelectComponent.prototype, "entityCategorySystemName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalSelectComponent.prototype, "density", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity)
    ], HierarchicalSelectComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HierarchicalSelectComponent.prototype, "validations", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalSelectComponent.prototype, "switchModes", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalSelectComponent.prototype, "selectedItemCategories", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalSelectComponent.prototype, "selectedItemFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HierarchicalSelectComponent.prototype, "viewMode", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HierarchicalSelectComponent.prototype, "editable", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], HierarchicalSelectComponent.prototype, "valueChange", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], HierarchicalSelectComponent.prototype, "validationEmitter", void 0);
    HierarchicalSelectComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'hierarchical-select',
            template: require('./hierarchical-select.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            cellCount: 4,
            groups: [{ identity: 'input', name: 'Input Elements' }],
            // todo TatevK changes this icon to svg
            iconInfo: 'fa-bars',
            name: 'Hierarchical Picker',
            nameKey: 'de.controls.hierarchical.title',
            settings: {
                main: hierarchical_select_settings_1.HierarchicalSelectSettingsComponent,
            },
            template: "\n              <hierarchical-select\n                  [id]=\"'%{id}'\"\n                  [isReadonly]=\"%{isReadonly}\"\n                  [title]=\"%{title}\"\n                  [titleKey]=\"%{titleKey}\"\n                  [entityCategorySystemName]=\"%{entityCategorySystemName}\"\n                  [density]=\"%{density}\"\n                  [entity]=\"contextEntity\"\n                  [validations]=\"validations\"\n                  [selectedItemCategories]=\"%{selectedItemCategories}\"\n                  [selectedItemFields]=\"%{selectedItemFields}\"\n                  [switchModes]=\"%{switchModes}\"\n                   (validationEmitter)=\"%{validationEmittedFor}\"\n                  [viewMode]=\"%{viewMode}\"\n                  [editable]=\"%{editable}\">\n              </hierarchical-select>\n            ",
            defaultActions: {
                validationEmittedFor: 'validationEmittedFor',
            },
        }),
        __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_message_language_service_client_js_1.LanguageService,
            core_1.ChangeDetectorRef,
            idm_validation_calculation_service_client_js_1.ValidationService])
    ], HierarchicalSelectComponent);
    return HierarchicalSelectComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.HierarchicalSelectComponent = HierarchicalSelectComponent;
//# sourceMappingURL=hierarchical-select.component.js.map